var vipdelay = 900;

// Ticket Meter
var GAmeterDance = function() {

    var $ga_meter, $bg, $counter, $notice, $accent, $ticks, percent, timeout, $accent, allow_glow;
    $ga_meter = $('div.ga-meter');
    $accent = $ga_meter.find('.accent');
    $ticks = $ga_meter.find('.ticksup');
    $bg = $ga_meter.find('.bar');
    $counter = $ga_meter.find('.bar .p .count');
    $notice = $('.ga-meter .mtitle>.anim');
    percent = $bg.data('percent');
    allow_glow = true;

    $ga_meter.fadeTo(300,.1);
    $ticks.fadeTo(300,.1);
    //$accent.css({'width': '1%'});

    setTimeout(function() {
        $ga_meter.fadeTo(1200,1);
    }, 300);

    setTimeout(function() {
        $notice.animate({'top': 0}, 1850, 'easeInOutExpo');
    }, 500);

    setTimeout(function() {
        $ticks.fadeTo(300,1);
    }, 200);

    setTimeout(function() {
        $accent.animate({'width': '100%'}, 2150, 'easeInOutExpo');
        $bg.animate({'width': percent + "%"}, 2150, 'easeInOutExpo') ;
    }, 500);

    setTimeout(function() {
        //$ga_meter.find('.ga .barbg>div').addClass('redPulse');
        $ga_meter.find('.allowglow').addClass('redShadow');
        //$ga_meter.find('.ga .accent>div').addClass('redPulse');
    }, 2000);

    setTimeout(function() {
        $counter.countTo({
            from: 0,
            to: percent,
            speed: 1450,
            refreshInterval: 10
        });
    }, 1200);
}


// Ticket Meter
var VIPmeterDance = function() {
    var $vip_meter, $bg, $counter, $notice, $accent, $ticks, percent, timeout, $accent, allow_glow;
    $vip_meter = $('div.vip-meter');
    $accent = $vip_meter.find('.accent');
    $ticks = $vip_meter.find('.ticksup');
    $bg = $vip_meter.find('.bar');
    $counter = $vip_meter.find('.bar .p .count');
    $notice = $('.vip-meter .mtitle>.anim');
    percent = $bg.data('percent');
    allow_glow = true;

    $vip_meter.fadeTo(300,.1);
    $ticks.fadeTo(300,.1);
    //$accent.css({'width': '1%'});

    setTimeout(function() {
        $vip_meter.fadeTo(1200,1);
    }, 300);

    setTimeout(function() {
        $notice.animate({'top': 0}, 1850, 'easeInOutExpo');
    }, 500);

    setTimeout(function() {
        $ticks.fadeTo(300,1);
    }, 200);

    setTimeout(function() {
        $accent.animate({'width': '100%'}, 2150, 'easeInOutExpo');
        $bg.animate({'width': percent + "%"}, 2150, 'easeInOutExpo') ;
    }, 500);

    setTimeout(function() {
        //$vip_meter.find('.ga .barbg>div').addClass('redPulse');
        $vip_meter.find('.allowglow').addClass('redShadow');
        //$vip_meter.find('.ga .accent>div').addClass('redPulse');
    }, 2000);

    setTimeout(function() {
        $counter.countTo({
            from: 0,
            to: percent,
            speed: 1450,
            refreshInterval: 10
        });
    }, 1200);
}


// Dynamic Ticket Meter
var dynamicMeterDance = function() {
    var staggerDelay = vipdelay;

    $('.dynamic-meter').each(function(index) {
        var $meter = $(this);
        var $fill = $meter.find('.dynamic-meter__fill');
        var $counter = $meter.find('.dynamic-meter__count');
        var percent = $fill.data('percent');
        var delay = index * staggerDelay;

        $meter.css('opacity', 0).fadeTo(600, 1);

        setTimeout(function() {
            $({p: 0}).animate({p: percent}, {
                duration: 2150,
                easing: 'easeInOutExpo',
                step: function(now) {
                    var clip = (100 - now);
                    $fill.css('clip-path', 'inset(0 ' + clip + '% 0 0 round 100px)');
                    $counter.text(Math.round(now));
                }
            });
        }, delay);
    });
}

// Legacy Meter click tracking
$(document).on('click', '.ticket-meter .btn-main', function() {
    var $meter = $(this).closest('.ticket-meter');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'select_item',
        'ecommerce': {
            'item_list_id': 'ticket_meter',
            'item_list_name': 'Ticket Meter',
            'items': [{
                'item_id': $(this).attr('href'),
                'item_name': $meter.data('meter-title'),
                'item_category': $(this).data('meter-element'),
                'meter_percent': $meter.data('meter-percent')
            }]
        }
    });
});

// Build ecommerce item from a dynamic meter element, merging ticket data when available
function getMeterItem($meter) {
    var ticket = $meter.data('meter-ticket') || {};
    var pageName = $meter.closest('.dynamic-meter-container').data('meter-page') || '';
    var listName = pageName ? 'Ticket Meter - ' + pageName : 'Ticket Meter';
    return $.extend({
        item_id: $meter.data('meter-id'),
        item_name: $meter.data('meter-title'),
        item_list_id: 'ticket_meter',
        item_list_name: listName,
        index: $meter.data('meter-index'),
        meter_percent: $meter.data('meter-percent')
    }, ticket);
}

// Dynamic Meter click tracking
$(document).on('click', '.dynamic-meter__track, .dynamic-meter__cta', function() {
    var $meter = $(this).closest('.dynamic-meter');
    var item = getMeterItem($meter);
    item.meter_element = $(this).data('meter-element');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'select_item',
        'ecommerce': {
            'item_list_id': item.item_list_id,
            'item_list_name': item.item_list_name,
            'items': [item]
        }
    });
});

// Dynamic Meter impression tracking (wrapped in DOM ready so container exists)
$(function() {
    var container = $('.dynamic-meter-container')[0];
    if (!container) return;

    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var items = [];
                $(container).find('.dynamic-meter').each(function() {
                    items.push(getMeterItem($(this)));
                });
                if (items.length) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ ecommerce: null });
                    var listName = $(container).data('meter-page');
                    listName = listName ? 'Ticket Meter - ' + listName : 'Ticket Meter';
                    window.dataLayer.push({
                        event: 'view_item_list',
                        ecommerce: {
                            item_list_id: 'ticket_meter',
                            item_list_name: listName,
                            items: items
                        }
                    });
                }
                observer.disconnect();
            }
        });
    }, { threshold: 0.5 });

    observer.observe(container);
});
